import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GaService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  pageView(path: string, title: string): void {
    if (!this.isBrowser()) return;

    gtag('event', 'page_view', {
      page_path: path,
      page_title: title
    });
  }

  setUser(id: string, nome: string) {
    if (!this.isBrowser()) return;

    gtag('set', { user_id: id });

    gtag('set', 'user_properties', {
      name: nome
    });
  }

  event(name: string, params?: Record<string, any>) {
    if (!this.isBrowser()) return;

    gtag('event', name, params);
  }

  setTrafficInternal() {
    gtag('set', 'user_properties', {
      traffic_type: 'internoegtec'
    });
  }
}
